export default function DateTimePicker(theme) {
  return {
    MuiDateTimePicker: {
      defaultProps: {
        slotProps: {
          textField: {
            // TODO make sure it's consistent after we add date format configuration to settings
            placeholder: 'MM/DD/YYYY 00:00:00',
            sx: {
              '& .MuiInputBase-input::placeholder': {
                color: theme.palette.text.disabled,
                opacity: 1,
              },
            },
          },
        },
      },
    },
  }
}
